import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import { PinPad, Wordmark } from "@/components/Brand";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function CounterLogin() {
  const { pinLogin } = useAuth();
  const nav = useNavigate();
  const [devices, setDevices] = useState([]);
  const [deviceId, setDeviceId] = useState(localStorage.getItem("patria_device") || "");
  const [username, setUsername] = useState("");
  const [step, setStep] = useState("username"); // username -> pin

  useEffect(() => {
    api.get("/devices").then(({ data }) => {
      setDevices(data);
    }).catch(() => toast.error("Could not load devices"));
  }, []);

  const onPin = async (pin) => {
    try {
      const u = await pinLogin(username.trim().toLowerCase(), pin, deviceId);
      toast.success(`Welcome, ${u.name}`);
      nav("/count");
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  const selectedDevice = devices.find((d) => d.id === deviceId);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 pad-safe">
      <button className="fixed top-5 left-5 btn btn-ghost h-10 px-4 text-sm" onClick={() => nav("/")} data-testid="back-home"><ArrowLeft size={16} /> Back</button>
      <div className="w-full max-w-md fadeup">
        <div className="text-center mb-6"><Wordmark className="inline-block" /></div>
        <div className="card p-8">
          {step === "username" && (
            <>
              <h1 className="font-serif text-3xl mb-1">Counter Sign In</h1>
              <p className="text-sm text-[color:var(--ink-2)] mb-6">Select this room's iPad, then enter your username.</p>
              <label className="block mb-4">
                <span className="label block mb-1.5">Campus Device</span>
                <select className="field" value={deviceId} onChange={(e) => setDeviceId(e.target.value)} data-testid="device-select">
                  <option value="">Select device…</option>
                  {devices.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
                </select>
              </label>
              <label className="block mb-6">
                <span className="label block mb-1.5">Username</span>
                <input className="field" value={username} onChange={(e) => setUsername(e.target.value.replace(/\s/g, ""))} data-testid="counter-username" placeholder="e.g. rancho1" autoCapitalize="none" autoCorrect="off" />
              </label>
              <button className="btn btn-primary w-full" disabled={!deviceId || !username} onClick={() => setStep("pin")} data-testid="counter-continue">Continue</button>
            </>
          )}
          {step === "pin" && (
            <>
              <div className="text-center mb-6">
                <h1 className="font-serif text-2xl">Enter PIN</h1>
                <p className="text-sm text-[color:var(--ink-2)]">{username}</p>
                <p className="text-xs text-[color:var(--muted)] mt-1">{selectedDevice?.name}</p>
              </div>
              <PinPad testid="counter-pinpad" onComplete={onPin} />
              <button className="btn btn-ghost w-full mt-6 h-11" onClick={() => setStep("username")} data-testid="counter-change">Change username/device</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
